// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
// import ContentPaste from "@material-ui/icons/ContentPaste";
import ReportsIcon from "@material-ui/icons/Assessment";
import MembersIcon from "@material-ui/icons/People";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import LoginIcon from "@material-ui/icons/Lock";
import GetAppIcon from "@material-ui/icons/GetApp";
import Notifications from "@material-ui/icons/Notifications";
import AddCircleIcon from '@material-ui/icons/AddCircle';

// core components/views
import DashboardPage from "views/Dashboard/Dashboard.jsx";
import ReportsPage from "views/Reports/Reports.jsx";
import UserProfile from "views/UserProfile/UserProfile.jsx";
import MembersPage from "views/Members/Members.jsx";
import Logout from "components/Logout/Logout.jsx";
import AlertsPage from "views/Alerts/Alerts.jsx";
import ServiceRequest from "views/ServiceRequest/ServiceRequest.jsx"

import Login from "views/Login/Login.jsx";

// All routes seen in the Sidebar (a.k.a Navbar)
const sidebarRoutes = [
  {
    path: "/login",
    sidebarName: "Login",
    navbarName: "",
    icon: LoginIcon,
    component: Login,
    tooltip: "Login"
  },
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "",
    icon: Dashboard,
    component: DashboardPage,
    tooltip: "View machine status"
  },
  {
    path: "/user",
    sidebarName: "Alert Settings",
    navbarName: "",
    icon: Person,
    component: UserProfile,
    tooltip: "Profile settings, email notifications"
  },
  {
    path: "/reports",
    sidebarName: "Reports",
    navbarName: "",
    icon: ReportsIcon,
    component: ReportsPage,
    tooltip: "Run manual reports"
  },
  {
    path: "/alerts",
    sidebarName: "Alerts",
    navbarName: "",
    icon: Notifications,
    component: AlertsPage,
    tooltip: "View alerts"
  },
  {
    path: "/members",
    sidebarName: "Members",
    navbarName: "",
    icon: MembersIcon,
    component: MembersPage,
    tooltip: "Add/Update members"
  },
  {
    path: "/service",
    sidebarName: "Service Request",
    navbarName: "",
    icon: AddCircleIcon,
    component: ServiceRequest,
    tooltip: "Request recycler service"
  },
  {
    path: "/manual",
    sidebarName: "User Manual",
    navbarName: "",
    icon: GetAppIcon,
    tooltip: "View/Download user manual"
  },
  {
    path: "/logout",
    sidebarName: "Logout",
    navbarName: "",
    icon: LogoutIcon,
    component: Logout,
    tooltip: "Logout"
  },
  { redirect: true, path: "/", to: "/login", navbarName: "Redirect" },
];

export default sidebarRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx